__turbopack_context__.v({
  "check_icon": "Dropdown-module-scss-module__4-wkQG__check_icon",
  "chevron": "Dropdown-module-scss-module__4-wkQG__chevron",
  "chevron_open": "Dropdown-module-scss-module__4-wkQG__chevron_open",
  "dim": "Dropdown-module-scss-module__4-wkQG__dim",
  "disabled": "Dropdown-module-scss-module__4-wkQG__disabled",
  "error": "Dropdown-module-scss-module__4-wkQG__error",
  "field_wrap": "Dropdown-module-scss-module__4-wkQG__field_wrap",
  "focused": "Dropdown-module-scss-module__4-wkQG__focused",
  "icon_slot": "Dropdown-module-scss-module__4-wkQG__icon_slot",
  "label": "Dropdown-module-scss-module__4-wkQG__label",
  "option": "Dropdown-module-scss-module__4-wkQG__option",
  "option_group_header": "Dropdown-module-scss-module__4-wkQG__option_group_header",
  "option_list": "Dropdown-module-scss-module__4-wkQG__option_list",
  "option_list_panel": "Dropdown-module-scss-module__4-wkQG__option_list_panel",
  "option_list_panel_sheet": "Dropdown-module-scss-module__4-wkQG__option_list_panel_sheet",
  "option_selected": "Dropdown-module-scss-module__4-wkQG__option_selected",
  "scrollbar_thumb": "Dropdown-module-scss-module__4-wkQG__scrollbar_thumb",
  "scrollbar_track": "Dropdown-module-scss-module__4-wkQG__scrollbar_track",
  "sheet-slide-up": "Dropdown-module-scss-module__4-wkQG__sheet-slide-up",
  "sheet_close": "Dropdown-module-scss-module__4-wkQG__sheet_close",
  "sheet_header": "Dropdown-module-scss-module__4-wkQG__sheet_header",
  "sheet_header_basic": "Dropdown-module-scss-module__4-wkQG__sheet_header_basic",
  "sheet_header_custom": "Dropdown-module-scss-module__4-wkQG__sheet_header_custom",
  "sheet_label_basic": "Dropdown-module-scss-module__4-wkQG__sheet_label_basic",
  "sheet_label_custom": "Dropdown-module-scss-module__4-wkQG__sheet_label_custom",
  "size_lg": "Dropdown-module-scss-module__4-wkQG__size_lg",
  "size_md": "Dropdown-module-scss-module__4-wkQG__size_md",
  "size_sm": "Dropdown-module-scss-module__4-wkQG__size_sm",
  "trigger_area": "Dropdown-module-scss-module__4-wkQG__trigger_area",
  "trigger_button": "Dropdown-module-scss-module__4-wkQG__trigger_button",
  "trigger_label": "Dropdown-module-scss-module__4-wkQG__trigger_label",
  "trigger_label_hidden": "Dropdown-module-scss-module__4-wkQG__trigger_label_hidden",
  "trigger_required": "Dropdown-module-scss-module__4-wkQG__trigger_required",
  "value_slot": "Dropdown-module-scss-module__4-wkQG__value_slot",
  "view": "Dropdown-module-scss-module__4-wkQG__view",
  "wrapper": "Dropdown-module-scss-module__4-wkQG__wrapper",
});
